module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.nalaganje) ? _c('div', [_c('div', {
    staticClass: "info-container"
  }, [(_vm.points / _vm.maxPoints > 0.75) ? _c('info-card', {
    attrs: {
      "title": _vm.$t('pages.exams.ratingResults.achievvedPoints'),
      "icon": "glyphicon glyphicon-ok",
      "iconColor": "#0073b7",
      "value": _vm.points + '/' + _vm.maxPoints
    }
  }) : _c('info-card', {
    attrs: {
      "title": _vm.$t('pages.exams.ratingResults.achievvedPoints'),
      "icon": "glyphicon glyphicon-ok",
      "iconColor": "#f39c12",
      "value": _vm.points + '/' + _vm.maxPoints
    }
  }), _vm._v(" "), _c('info-card', {
    attrs: {
      "title": _vm.$t('pages.exams.ratingResults.ratingChange'),
      "icon": "glyphicon glyphicon-stats",
      "iconColor": "#0073b7",
      "previous": _vm.oldRating,
      "value": _vm.newRating
    }
  }), _vm._v(" "), (_vm.newRatingDeviation <= 70) ? _c('info-card', {
    attrs: {
      "title": _vm.$t('pages.exams.ratingResults.ratingAccuracy'),
      "icon": "fa fa-bullseye",
      "iconColor": "#0073b7",
      "previous": Math.round((1 - _vm.oldRatingDeviation / 350) * 100),
      "value": Math.round((1 - _vm.newRatingDeviation / 350) * 100) + '%'
    }
  }) : (_vm.newRatingDeviation <= 180) ? _c('info-card', {
    attrs: {
      "title": _vm.$t('pages.exams.ratingResults.ratingAccuracy'),
      "icon": "fa fa-bullseye",
      "iconColor": "#f39c12",
      "previous": Math.round((1 - _vm.oldRatingDeviation / 350) * 100),
      "value": Math.round((1 - _vm.newRatingDeviation / 350) * 100) + '%'
    }
  }) : _c('info-card', {
    attrs: {
      "title": _vm.$t('pages.exams.ratingResults.ratingAccuracy'),
      "icon": "fa fa-bullseye",
      "iconColor": "#dd4b39",
      "previous": Math.round((1 - _vm.oldRatingDeviation / 350) * 100),
      "value": Math.round((1 - _vm.newRatingDeviation / 350) * 100) + '%'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "second-container"
  }, [_c('div', {
    staticClass: "view-your-answers-card",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showQuestions($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-card-content"
  }, [_c('span', {
    staticStyle: {
      "font-size": "23px",
      "font-weight": "bold",
      "color": "#3a3a3a",
      "margin": "10px 10px 10px 0"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.viewYourAnswers")))])])]), _vm._v(" "), (_vm.latestRatingDeviation > 87.5) ? _c('leaderboard-card', {
    attrs: {
      "title": "Lestvica",
      "content": "Za uvrstitev na lestvico rešite več Rating kvizov",
      "progress": (1 - _vm.latestRatingDeviation / 350) * 100
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('leaderboard', {
    staticStyle: {
      "margin": "30px 0"
    },
    attrs: {
      "gid": _vm.gid
    }
  }), _vm._v(" "), (_vm.zgodovinaRatinga) ? _c('graph', {
    attrs: {
      "ratingHistory": _vm.zgodovinaRatinga
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-list-ul",
    staticStyle: {
      "font-size": "50px",
      "height": "100%",
      "padding": "12px",
      "color": "black !important"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-abf39e40", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abf39e40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rating/RatingExamResults.vue
// module id = 1466
// module chunks = 1